module.exports = __webpack_public_path__ + "img/bg-masthead-mb.3d7be153.png";